(function () {
	'use strict';

	angular
		.module('invesfleet')
		.factory('productoService', productoService);

    productoService.$inject = ['$http', '$q', 'endPoints', 'authorization'];

	function productoService($http, $q, endPoints, authorization) {

		var service = {
			getList: getList,
			addProduct: addProduct,
            getProduct: getProduct,
            deleteById: deleteById

		};

		return service;

		function getList() {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.productos.getList
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response);
			},
            function (response) {
                deferred.reject(null);
            });
			return deferred.promise;
		}

        function addProduct(product, andConditions, orConditions, habilitarIdaVuelta, zonaIdSource, zonaIdDestination) {
			var deferred = $q.defer();

            var data = {
                product,
                andConditions,
                orConditions,
                habilitarIdaVuelta,
                zonaIdSource,
                zonaIdDestination
            };
            
			var request = {
				method: 'POST',
				url: endPoints.productos.add,
                data: data
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response);
			},
            function (response) {
                deferred.reject(null);
            });
			return deferred.promise;
		}

		function getProduct(id){
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.productos.get + "?productId=" + id
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response);
			},
            function (response) {
                deferred.reject(null);
            });
			return deferred.promise;
        }

        function deleteById(productsIds) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.productos.deleteById,
                data: productsIds
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;

        }
	}
})();